module.exports = __webpack_public_path__ + "img/less.7db3931f.svg";